import { Container, Sprite, Texture } from 'pixi.js';
import Reel from './Reel';
import Lines from './Lines';
import StickyWilds from './StickyWilds';
import CoeffsView from './CoeffsView';
import { Tween, Easing } from '@tweenjs/tween.js';
import { EVENTS } from '../lib/constants';
import HELPERS from '../lib/globals/helpers/Helpers';
import { GameConfigs } from '../lib/globals/GameConfigs';
import { isDesktop, isMobile, isTablet } from 'react-device-detect';

class Reels extends Container {
	reels = null;
	config = null;
	bg = null;
	maskGraphics = null;
	fg = null;
	lines = null;
	finishedReels = 0;
	currentItems = null;
	baiting = [];
	rotating = false;
	fastS = false;
	stickyWilds = null;
	emptyreel = [
		[0, 1, 2],
		[3, 4, 5],
		[6, 7, 8],
		[9, 0, 1],
		[2, 3, 4]
	];
	coeffsView = null;

	constructor(cfg) {
		super();
		this.reels = [];
		this.config = cfg;
		this.borderActive = false;
		this.star_accelerate = false;

		if (this.config.animations !== undefined) {
			this.addBorders();
		}
		if (this.config.bg) {
			this.bg = Sprite.from(Texture.from(this.config.bg));
			this.addChildA(this.bg);
		}

		for (let i = 0; i < this.config.width; i++) {
			var reel = new Reel(i, this.config, this.reelHandler.bind(this));
			reel.x = this.config.iconWidth * i - 3;
			this.addChild(reel);
			this.reels.push(reel);
		}
		this.lines = new Lines(
			cfg.linesConfig,
			this.linesHandler.bind(this),
			this.reels
		);
		if (this.config.reelsMask) {
			if (this.maskGraphics != null) {
				this.removeChild(this.maskGraphics);
			}
		}
		if (this.config.divider) {
			this.fg = new Sprite();
			for (let i = 0; i < this.config.width - 1; i++) {
				var divider = Sprite.from(Texture.from(this.config.divider));
				divider.x =
					(i + 1) * this.config.iconWidth -
					(this.config.iconWidth - this.config.iconRealWidth) / 2 -
					0.15 * (i + 1);
				this.fg.addChild(divider);
			}
			this.addChild(this.fg);
		}
		this.createbaitFrame();
		window.addEventListener('keydown', this.handleKeyDown.bind(this));
		this.coeffsView = new CoeffsView(this.reels, this.lines);
		this.addChild(this.coeffsView);

		if (this.config.border) {
			this.sortableChildren = true;
			this.border = Sprite.from(Texture.from(this.config.border));
			this.addChildAt(this.border, 0);
			this.border.position.x = isDesktop ? -3 : -1.5;
			this.border.position.y = isDesktop ? -4 : -2;
			this.border.eventMode = 'none';
			// this.border.scale.set(1.016, 1.018)
			//todo change zIndex on reel start and end
			this.border.zIndex = 100;
		}
		if (this.config.additional_assets) {
			for (let i = 0; i < this.config.additional_assets.length; i++) {
				this.asset = Sprite.from(
					Texture.from(this.config.additional_assets[i].img)
				);
				this.addChildAt(this.asset, 0);
				this.asset.position.set(
					this.config.additional_assets[i].pos.x,
					this.config.additional_assets[i].pos.y
				);
				this.asset.anchor.set(
					this.config.additional_assets[i].anchor.x,
					this.config.additional_assets[i].anchor.y
				);
				this.asset.name = `asset_${i}`;
				this.asset.zIndex = 101;
				this.asset.eventMode = 'none';
				if (!isDesktop) {
					this.asset.scale.set(0.5);
				}
			}
		}
	}

	createbaitFrame() {
		//LEFT FRAME
		this.frame_left = HELPERS.getAnimatedSprite({
			pattern: 'bait_000$.png',
			start: 0,
			end: 23,
			speed: 0.5,
			precision: 2,
			loop: true
		});

		this.frame_leftW = isMobile || isTablet ? 135 / 2 - 12 : 270 / 2 - 25;
		this.frame_leftH = isMobile || isTablet ? 371 / 2 - 15 : 743 / 2 - 30;
		this.frame_left.x = 0;
		this.frame_left.y = this.frame_leftH;
		this.frame_left.anchor.set(0.5, 0.5);
		this.frame_left.alpha = 0;
		this.addChild(this.frame_left);
		this.frame_left.eventMode = 'none';

		this.frame_right = HELPERS.getAnimatedSprite({
			pattern: 'bait_000$.png',
			start: 0,
			end: 23,
			speed: 0.5,
			precision: 2,
			loop: true
		});
		this.frame_rightW = isMobile || isTablet ? 135 / 2 - 12 : 270 / 2 - 25;
		this.frame_rightH = isMobile || isTablet ? 371 / 2 - 15 : 743 / 2 - 30;
		this.frame_right.x = 0;
		this.frame_right.y = this.frame_rightH;
		this.frame_right.anchor.set(0.5, 0.5);
		this.frame_right.alpha = 0;
		this.frame_right.eventMode = 'none';
		this.addChild(this.frame_right);

		this.frame_right.zIndex = 1100;
		this.frame_left.zIndex = 1100;
		if (GameConfigs.settings.game_animation) {
			this.frame_left.gotoAndPlay(0);
			this.frame_right.gotoAndPlay(0);
		} else {
			this.frame_left.gotoAndStop(0);
			this.frame_right.gotoAndStop(0);
		}
		if (this.coeffsView) {
			this.addChild(this.coeffsView);
		}
	}

	handleKeyDown(event) {
		if (event.keyCode === 32) {
			if (this.rotating) {
				this.fastStop();
			}
		}
	}

	handleBodyClick(event) {
		this.fastStop();
	}

	addBorders() {
		this.sortableChildren = true;
		this.reel_border = HELPERS.getAnimatedSprite(this.config.animations.bg);
		this.reel_border.alpha = 0;
		this.reel_border.zIndex = 1000;
		this.reel_border.position.x = isDesktop ? -3 : -1.5;
		this.reel_border.position.y = isDesktop ? -4 : -2;
		this.reel_border.interactive = false;
		this.reel_border.eventMode = 'none';
		this.addChildAt(this.reel_border, 0);
	}

	stopBorder() {
		this.reel_border.alpha = 0;
		if (GameConfigs.settings.game_animation) {
			this.reel_border.gotoAndPlay(0);
		}
	}

	startBorder() {
		this.reel_border.alpha = 1;
		if (GameConfigs.settings.game_animation) {
			this.reel_border.gotoAndPlay(0);
		} else {
			this.reel_border.gotoAndStop(0);
		}
	}

	resetBonus() {
		if (this.stickyWilds === null) {
			return;
		}
		for (let i = 0; i < this.reels.length; i++) {
			this.reels[i].restoreWilds();
		}
		this.lines.reset();
		new Tween(this.stickyWilds)
			.to({ alpha: 0 }, 250)
			.easing(Easing.Linear.None)
			.onComplete(() => {
				this.removeChild(this.stickyWilds);
				this.stickyWilds = null;
				this.lines.stickyWilds = null;
			})
			.start();
		let result = this.config.icons.filter((icon) => icon.isWild);
		result[0].animation.fg2Index = 0;
	}

	reelHandler(event) {
		this.finishedReels++;
		if (this.stickyWilds !== null) {
			//this.reels[event.id].replaceWilds(this.stickyWilds.wilds[event.id]);
		}
		if (this.finishedReels === this.reels.length) {
			this.star_accelerate = false;
			HELPERS.dispatchCustomEvent(EVENTS.BAIT, { bait: false });
			//   this.mask = null
			//   this.maskGraphics.alpha = 0;
			for (let i = 0; i < this.reels.length; i++) {
				this.reels[i].stopLoopItems();
			}
			new Tween(this.frame_left)
				.to({ alpha: 0 }, 200)
				.easing(Easing.Linear.None)
				.start();
			new Tween(this.frame_right)
				.to({ alpha: 0 }, 200)
				.easing(Easing.Linear.None)
				.start();
			if (this.stickyWilds) {
				this.stickyWilds.setWilds(
					this.currentItems.wilds,
					this.currentItems.wildmultiplier
				);
				if (this.stickyWilds != null) {
					for (let i = 0; i < this.reels.length; i++) {
						this.reels[i].replaceWilds(this.stickyWilds.wilds[i]);
					}
				}
			}

			this.lines.animate(this.currentItems.winlines);
			// setTimeout(() => {
			this.rotating = false;
			HELPERS.dispatchCustomEvent(EVENTS.REEL_FINISHED, {});
			this.stopBorder();
			// }, 100);
		}

		if (!this.fastS) {
			if (event.id < this.baiting.length - 1) {
				if (this.baiting[event.id + 1]) {
					window.sm.play({ name: 'bait_sfx' });
					if (!this.star_accelerate) {
						this.star_accelerate = true;
						HELPERS.dispatchCustomEvent(EVENTS.BAIT, { bait: true });
					}
					if (this.frame_left.alpha === 0) {
						this.frame_left.x =
							this.config.iconWidth * (event.id + 1) - (isDesktop ? 10 : 5);
						this.frame_right.x =
							this.config.iconWidth * (event.id + 1) +
							this.config.iconWidth -
							event.id * 4 +
							(isDesktop ? 0 : 0);
						new Tween(this.frame_left)
							.to({ alpha: 1 }, 50)
							.easing(Easing.Linear.None)
							.start();
						new Tween(this.frame_right)
							.to({ alpha: 1 }, 50)
							.easing(Easing.Linear.None)
							.start();
					} else {
						new Tween(this.frame_left)
							.to({ alpha: 0 }, 220)
							.easing(Easing.Linear.None)
							.onComplete(() => {
								this.frame_left.x =
									this.config.iconWidth * (event.id + 1) - (isDesktop ? 0 : 0);
								new Tween(this.frame_left)
									.to({ alpha: 1 }, 220)
									.easing(Easing.Linear.None)
									.start();
								// window.sm.play({ name: "bait_sfx" });
							})
							.start();
						new Tween(this.frame_right)
							.to({ alpha: 0 }, 220)
							.easing(Easing.Linear.None)
							.onComplete(() => {
								this.frame_right.x =
									this.config.iconWidth * (event.id + 1) +
									this.config.iconWidth -
									event.id * 4 +
									(isDesktop ? -5 : 0);
								new Tween(this.frame_right)
									.to({ alpha: 1 }, 220)
									.easing(Easing.Linear.None)
									.start();
							})
							.start();
					}
				}
			}
		}
	}

	linesHandler(eventdata) {
		HELPERS.dispatchCustomEvent(eventdata.type, eventdata.line);
	}

	start() {
		if (this.rotating) {
			return;
		}
		HELPERS.dispatchCustomEvent(EVENTS.REEL_STARTED, {});
		this.fastS = false;
		this.rotating = true;
		this.lines.reset();
		this.baiting = [false, false, false, false, false];
		this.finishedReels = 0;
		this.startBorder();

		for (let i = 0; i < this.reels.length; i++) {
			// this.reels[i].start(100 * i);
			this.reels[i].start(50 * i);
		}
	}

	fastStop() {
		// console.log('fastStop')
		this.fastS = true;
		for (let i = 0; i < this.reels.length; i++) {
			this.reels[i].fastStop();
		}
	}

	emergencyStop() {
		if (this.currentItems === undefined || this.currentItems === null) {
			this.stop({
				reels: this.emptyreel,
				winlines: []
			});
		} else {
			this.stop({ reels: this.currentItems.reels, winlines: [] });
		}
	}

	stop(items, isFast) {
		if (!this.fastS) {
			this.fastS = isFast;
		}
		if (items) {
			if (items && items.game_type === 'bonus') {
				if (this.stickyWilds === null) {
					this.stickyWilds = new StickyWilds(this.config);
					this.lines.stickyWilds = this.stickyWilds;
					this.addChild(this.stickyWilds);
					if (this.coeffsView) {
						this.addChild(this.coeffsView);
					}
				}
				let result = this.config.icons.filter((icon) => icon.isWild);
				result[0].animation.fg2Index = items.wildmultiplier - 1;
				//this.stickyWilds.setWilds(items.wilds, items.wildmultiplier);
			}
			//this.fastS
			var times = new Array(this.config.width).fill(0);
			var stopMode = new Array(this.config.width).fill(Reel.STOP_SIMPLE);
			let scattersCnt = 0;
			let timeout = 1;
			for (let i = 0; i < items.reels.length; i++) {
				if (scattersCnt > 1) {
					times[i] = this.config.baitTime * timeout;
					stopMode[i] = Reel.STOP_BAIT;
					this.baiting[i] = true;
					timeout = timeout + 3;
				}
				if (this.fastS) {
					stopMode = new Array(this.config.width).fill(Reel.STOP_FAST);
				}
				if (items.game_type === 'bonus') {
					if (this.fastS) {
						stopMode = new Array(this.config.width).fill(Reel.STOP_FAST);
					} else {
						stopMode = new Array(this.config.width).fill(Reel.STOP_SIMPLE);
					}
				}
				const element = items.reels[i];
				for (let t = 0; t < element.length; t++) {
					const itm = element[t];
					if (this.config.icons[itm].isScatter) {
						scattersCnt++;
					}
				}
			}
			this.currentItems = items;
			for (let i = 0; i < this.reels.length; i++) {
				this.reels[i].stop(
					items.reels[i],
					times[i],
					stopMode[i],
					items.game_type === 'bonus'
				);
			}
		}
	}

	animate(line) {
		for (let i = 0; i < this.reels.length; i++) {
			this.reels[i].animate(line);
		}
	}
}

export default Reels;
